module.exports = __webpack_public_path__ + "images/ezacc/cursor-white.svg";